import { ArrowRightIcon } from '@radix-ui/react-icons'
import type { Data } from '@repo/strapi'
import { Paragraph } from '@/components/typography/Paragraph'
import { cn } from '@/lib/styles'

interface TileLinkProps {
	link?: Data.Component<'utilities.link'> | null
	className?: string
}

export function TileLink({ link, className }: TileLinkProps) {
	if (!link?.label) return null

	return (
		<div className={cn('flex items-center justify-start text-left', className)}>
			<Paragraph
				fontSize="bodyRegularSmall"
				className="text-brand-black group-hover:text-brand-salmon"
			>
				{link.label}
			</Paragraph>
			<ArrowRightIcon className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-2 group-hover:text-brand-salmon" />
		</div>
	)
}
